module.exports = __webpack_public_path__ + "img/foot-grid.ea809016.png";